import { useCallback, useEffect, useMemo, useState } from 'react'
import {
  TIME_RANGE_SLIDER_DEFAULT_MAX,
  TIME_RANGE_SLIDER_DEFAULT_MIN,
  useTimeRangeSlideUtils,
} from '@/components/Surface'
import { TimeRangeFilterResponsiveProps } from './TimeRangeFilterResponsive.types'

export const useTimeRangeFilterResponsiveController = ({
  min = TIME_RANGE_SLIDER_DEFAULT_MIN,
  max = TIME_RANGE_SLIDER_DEFAULT_MAX,
  value,
  onChange,
  label,
}: TimeRangeFilterResponsiveProps) => {
  const { getDurationValueText } = useTimeRangeSlideUtils()

  const hasValue = value.min !== min || value.max !== max

  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const [intermediateValue, setIntermediateValue] =
    useState<TimeRangeFilterResponsiveProps['value']>(value)

  const closeDrawer = useCallback(() => {
    setIsDrawerOpen(false)
    setIntermediateValue(value)
  }, [value])

  const onApply = useCallback(() => {
    onChange?.(intermediateValue)

    setIsDrawerOpen(false)
  }, [onChange, intermediateValue])

  // sync value changes from parent
  useEffect(() => {
    setIntermediateValue(value)
  }, [value])

  const displayLabel = useMemo(() => {
    if (!hasValue) return label

    return `${label}: ${getDurationValueText({ value, min, max })}`
  }, [getDurationValueText, hasValue, label, max, min, value])

  return {
    hasValue,
    displayLabel,
    isDrawerOpen,
    setIsDrawerOpen,
    closeDrawer,
    onApply,
    intermediateValue,
    setIntermediateValue,
  }
}
